import api from "@/api";

export default {
  actions: {
    createTransaction: (_, transaction) =>
      api({ requiresAuth: true }).post("/v1/transactions", { ...transaction }),
  },
};
